/* Cidadão do concept idle (folha 8 dirs em /website/hero-avatar.png) */

.lp-citizen {
  --lp-citizen-size: 96px;
  display: block;
  flex-shrink: 0;
  width: var(--lp-citizen-size);
  height: var(--lp-citizen-size);
  background-image: url('/website/hero-avatar.png');
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: calc(var(--lp-citizen-size) * 8) var(--lp-citizen-size);
  image-rendering: pixelated;
  image-rendering: crisp-edges;
}

.lp-citizen--sm {
  --lp-citizen-size: 48px;
}

.lp-citizen--md {
  --lp-citizen-size: 72px;
}

.lp-citizen--lg {
  --lp-citizen-size: 96px;
}

@media (prefers-reduced-motion: no-preference) {
  .lp-citizen--spin {
    animation: lp-citizen-turn 1.6s steps(8) infinite;
  }
}

@keyframes lp-citizen-turn {
  from {
    background-position: 0 0;
  }
  to {
    background-position: calc(var(--lp-citizen-size) * -8) 0;
  }
}
